<template>
  <v-app>
    <v-app-bar app flat absolute color="transparent">
      <div class="boxed-container w-full">
        <div class="d-flex align-center mx-6">
          <router-link to="/" class="d-flex align-center text-decoration-none">
            <v-img
              :src="brandLogoFull"
              height="50px"
              max-width="50px"
              alt="logo"
              contain
              eager
              class="app-logo me-3"
            ></v-img>
          </router-link>

          <v-spacer></v-spacer>

          <language-switcher></language-switcher>
          <!-- <theme-switcher></theme-switcher> -->
          <app-bar-user-menu v-if="isAuthentication"></app-bar-user-menu>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container boxed-container pa-6">
        <slot></slot>
      </div>
    </v-main>

    <layout-footer></layout-footer>
  </v-app>
</template>

<script>
import { computed, onMounted, reactive, ref, watch } from "@vue/composition-api";
import { mdiMagnify, mdiBellOutline, mdiGithub } from "@mdi/js";
import VerticalNavMenu from "./vertical-nav-menu/VerticalNavMenu.vue";
import ThemeSwitcher from "./ThemeSwitcher.vue";
import AppBarUserMenu from "./AppBarUserMenu.vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";
import LayoutFooter from "./LayoutFooter.vue";

export default {
  components: {
    VerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
    LanguageSwitcher,
    LayoutFooter,
  },
  setup(props, { root }) {
    const brand = computed(() => root.$store.getters.brand);
    const brandLogoFull = computed(() => brand.value?.logoFull || require("@/assets/images/logo-full.png"));
    const isAuthentication = computed(() => root.$store.getters.isAuthentication);
    const searchInput = ref(null);
    const searchItems = reactive(
      root.$router.options.routes
        .filter((each) => each.meta && each.meta.searchLabel)
        .sort((a, b) => {
          const fa = a.meta.searchLabel.toLowerCase();
          const fb = b.meta.searchLabel.toLowerCase();
          if (fa < fb) return -1;
          if (fa > fb) return 1;

          return 0;
        }),
    );

    const customFilter = (item, queryText) => {
      const searchText = queryText.toLowerCase();
      const keywords = item.meta.keywords.map((each) => each.toLowerCase());

      return (
        keywords.find((each) => each.indexOf(searchText) > -1) ||
        item.meta.searchLabel.toLowerCase().indexOf(searchText) > -1
      );
    };

    watch(searchInput, (value) => {
      if (!!value && root.$route.name !== value) root.$router.push({ name: value });
    });

    return {
      brandLogoFull,
      isAuthentication,
      searchInput,
      searchItems,
      customFilter,
      icons: {
        mdiMagnify,
        mdiBellOutline,
        mdiGithub,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}
</style>
